import styled from 'styled-components';
import { media } from '@/styles/responsive';

export const Wrapper = styled.div`
  max-width: 720px;
  margin: 0 auto;
`;

export const Intro = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.colors['neutral-70']};
  margin: 0 0 32px;
  line-height: 1.5;
`;

export const CategorySection = styled.div`
  margin-bottom: 28px;
`;

export const CategoryHeader = styled.div`
  margin-bottom: 12px;
`;

export const CategoryLabel = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors['neutral-100']};
`;

export const CategoryDesc = styled.div`
  font-size: 13px;
  color: ${({ theme }) => theme.colors['neutral-70']};
  margin-top: 2px;
`;

export const ProviderGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 8px;

  ${media.mobile} {
    grid-template-columns: 1fr;
  }
`;

export const ProviderCard = styled.button<{ $selected: boolean; $disabled: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 12px;
  border: 2px solid ${({ $selected, theme }) =>
    $selected ? theme.colors['primary-60'] : theme.colors['neutral-20']};
  background: ${({ $selected, theme }) =>
    $selected ? `${theme.colors['primary-60']}08` : theme.colors['neutral-0']};
  cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.6 : 1)};
  text-align: left;
  font-family: inherit;
  transition: all 200ms cubic-bezier(0.2, 0.8, 0.4, 1);
  min-height: 44px;
  -webkit-tap-highlight-color: transparent;

  &:hover {
    border-color: ${({ $selected, $disabled, theme }) =>
      $disabled
        ? theme.colors['neutral-20']
        : $selected
          ? theme.colors['primary-60']
          : theme.colors['neutral-50']};
  }

  &:active {
    background: ${({ $disabled, theme }) =>
      $disabled ? 'transparent' : theme.colors['secondary-20']};
  }
`;

export const ProviderInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const ProviderName = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors['neutral-100']};
`;

export const ProviderDesc = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors['neutral-70']};
  margin-top: 1px;
`;

export const Badge = styled.span<{ $variant: 'available' | 'coming_soon' | 'manual' }>`
  display: inline-block;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 500;
  white-space: nowrap;
  ${({ $variant }) => {
    switch ($variant) {
      case 'available':
        return 'background: #F0FDF4; color: #16A34A; border: 1px solid #BBF7D0;';
      case 'coming_soon':
        return 'background: #FFFBEB; color: #D97706; border: 1px solid #FDE68A;';
      case 'manual':
        return 'background: #F4F4F5; color: #71717A; border: 1px solid #E4E4E7;';
      default:
        return '';
    }
  }}
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: 16px;
  margin-top: 8px;
  border-top: 1px solid ${({ theme }) => theme.colors['neutral-20']};

  ${media.mobile} {
    flex-direction: column;

    button {
      width: 100%;
    }
  }
`;
